import React from 'react'
import { IStockConfirmationStatus } from 'models/seller'
import { appActions, appSelectors } from 'store/app'
import { useAppDispatch, useAppSelector } from './useReduxHooks'

// Статус остатков читают несколько разделов кабинета. Полосу «магазин отключён»
// обновляем из любого такого ответа, но только по своему магазину: супер-админ
// смотрит чужие
export const useStoreHiddenSync = () => {
  const dispatch = useAppDispatch()
  const ownSellerId = useAppSelector(appSelectors.selectSellerId)

  return React.useCallback(
    (status: IStockConfirmationStatus) => {
      if (!ownSellerId || String(status.sellerId) !== ownSellerId) return
      dispatch(
        appActions.setStoreHidden({
          isStoreHidden: Boolean(status.isStoreHidden),
          isHiddenBySeller: Boolean(status.isHiddenBySeller)
        })
      )
    },
    [dispatch, ownSellerId]
  )
}
